// extracted by mini-css-extract-plugin
module.exports = {"access-denied":"T1_sqT","msg":"_33_hSV","joinNow":"_9ijeIM","policy":"ncZd8H","copyright":"_2PdeKF"};